<template>
  <div id="pageNotFound" class="center page-not-found">
    <div class="number">404</div>
    <div class="text fs-40">{{ $t('fourZeroFour.looks_like_somehing') }}</div>
    <div class="fs-24 mb-40">{{ $t('fourZeroFour.the_page_you') }}</div>
    <el-button class="home-page" @click="$router.push('/')">{{ $t('fourZeroFour.home_page') }}</el-button>
  </div>
</template>
<script>
export default {
  name: "pageNotFound",
  nounted () {
    document.title = "My Happily - Page not found!";
  }
}
</script>
<style lang="scss" scoped>
@keyframes lightenText {
  0% {color: #74747430;}
  29% {color: #74747430;}
  31% {color: #74747410;}
  32% {color: #74747403;}
  34% {color: #74747410;}
  36% {color: #74747400;}
  38% {color: #74747430;}
  100% {color: #74747430;}
}
.page-not-found {
  color: #74747430;
  margin-top: 15vh;
}
.number {
  font-size: 200px;
  font-weight: 800;
  animation: lightenText;
  animation-duration: 8s;
  animation-iteration-count: infinite;
}
#pageNotFound .el-button.home-page {
  margin-left: 0;
  font-weight: 700;
  font-size: 18px;
  height: 52px;
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #fff;
}
</style>